import React from "react";
import "./tabNavigation.css";

const TabNavigation = ({ tabs, activeTab, onTabClick, className = "" }) => {
  const handleTabClick = (tabId) => {
    onTabClick(tabId);
  };

  return (
    <div className={`tab-navigation ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => handleTabClick(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
